import React, { createContext } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useLoggedIn } from 'components/useLogin';

function PrivateRoute({ component: Component, ...rest }) {
  return useLoggedIn() ? <Outlet /> : <Navigate to='login' replace />;
}

export default PrivateRoute;
